import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UiKitModule } from "@jack-sparrow-libraries/ui-kit";
import { FormsModule } from "@angular/forms";
import { AlertAdriAyComponent } from "@featuresAY/lecteur/components/alert-adri/alert-adri-ay.component";
import { LostConnexionCbaLinkDialogComponent } from "@featuresAY/lecteur/components/lost-connexion-cba-link-dialog/lost-connexion-cba-link-dialog.component";
import { LostConnexionTedLecteurDialogComponent } from "@featuresAY/lecteur/components/lost-connexion-ted-lecteur-dialog/lost-connexion-ted-lecteur-dialog.component";
import { CpsNotFoundDialogComponent } from "@featuresAY/lecteur/components/cps-not-found-dialog/cps-not-found-dialog.component";
import { CpsCertificatInvalideDialogComponent } from "@featuresAY/lecteur/components/cps-certificat-invalide-dialog/cps-certificat-invalide-dialog.component";
import { CvNotFoundDialogComponent } from "@featuresAY/lecteur/components/cv-not-found-dialog/cv-not-found-dialog.component";
import { CbaWebListModule } from "@featuresAY/ordonnance-web-ay/components/cba-web-list/cba-web-list.module";

const components = [
	AlertAdriAyComponent,
	LostConnexionCbaLinkDialogComponent,
	LostConnexionTedLecteurDialogComponent,
	CpsNotFoundDialogComponent,
	CpsCertificatInvalideDialogComponent,
	CvNotFoundDialogComponent,
];

@NgModule({
	declarations: [...components],
	imports: [CommonModule, UiKitModule, FormsModule, CbaWebListModule],
	exports: [...components],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LecteurModule {}
